export default "__VITE_ASSET__g2aeEb70__"